/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */

import { useState, useContext } from "react";
import axios from "axios";
import { API_URL, showAlert, AuthContext } from "../util/api";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../header";
import Footer from "../footer";
import "./login_new.css";

const Login = () => {
  const navigate = useNavigate();
  const { login, patientFunction, doctorFunction } = useContext(AuthContext);

  const [data, setData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

 
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/auth/login`, data);

      if (response.status === 200 && response.data.status === "successful") {
        login(response.data.token, response.data.user);

        const role = response.data.user.role;

        if (role === "patient") {
          patientFunction(response.data.profile, response.data.user);
        }

        if (role === "doctor") {
          doctorFunction(response.data.profile, response.data.user);
        }

        showAlert("success", "Success!", "Login successful");
        navigate("/select-role");
      } else {
        showAlert("error", "Error!", response.data.message);
      }
    } catch (error) {
      showAlert("error", "Error!", "Server error. Check your network.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar menuColor="red" />

      <div className="login-wrapper">
        <div className="login-card">
          
          {/* LEFT SECTION */}
          <div className="login-left">
            <h1>Welcome Back</h1>
            <p>
              Securely access your account and manage your health records,
              appointments, and consultations.
            </p>
          </div>

          {/* RIGHT SECTION */}
          <div className="login-right">
            <h2>Login</h2>

            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <input
                  type="email"
                  required
                  value={data.email}
                  onChange={(e) =>
                    setData({ ...data, email: e.target.value })
                  }
                />
                <label>Email Address</label>
              </div>

              <div className="input-group">
                <input
                  type="password"
                  required
                  value={data.password}
                  onChange={(e) =>
                    setData({ ...data, password: e.target.value })
                  }
                />
                <label>Password</label>
              </div>

              <button
                type="submit"
                className="login-btn"
                disabled={loading}
              >
                {loading ? "Signing in..." : "Login"}
              </button>
            </form>

            <div className="login-links">
              <Link to="/forgot-password">Forgot password?</Link>
              <span>|</span>
              <Link to="/register">Create account</Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Login;
